// Custom scrollbar styles
export const customScrollbarStyles = `
  /* WebKit browsers (Chrome, Safari, Edge) */
  .custom-scrollbar::-webkit-scrollbar {
    width: 8px;
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 4px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    transition: all 0.2s ease;
    border: 2px solid transparent;
    background-clip: content-box;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.25);
  }

  /* Dark mode */
  .dark .custom-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.15);
  }

  .dark .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.25);
  }

  /* Firefox */
  .custom-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
  }

  .dark .custom-scrollbar {
    scrollbar-color: rgba(255, 255, 255, 0.15) transparent;
  }

  /* Smooth scrolling */
  .custom-scrollbar {
    scroll-behavior: smooth;
  }

  /* Hide scrollbar when not needed */
  .custom-scrollbar:not(:hover)::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.08);
  }

  .dark .custom-scrollbar:not(:hover)::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.08);
  }

  /* Ultra-thin scrollbar on hover for more Apple-like feel */
  .custom-scrollbar:hover::-webkit-scrollbar {
    width: 10px;
  }

  /* Dropdown specific styling */
  .dropdown-scrollbar::-webkit-scrollbar {
    width: 6px;
  }

  .dropdown-scrollbar::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 3px;
    margin: 4px 0;
  }

  .dropdown-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.12);
    border-radius: 3px;
    transition: all 0.2s ease;
  }

  .dropdown-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }

  .dark .dropdown-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.12);
  }

  .dark .dropdown-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  .dropdown-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.12) transparent;
  }

  .dark .dropdown-scrollbar {
    scrollbar-color: rgba(255, 255, 255, 0.12) transparent;
  }
`;

// Inject styles into the document head
export const injectCustomScrollbarStyles = () => {
  const styleId = 'tools-panel-scrollbar-styles';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = customScrollbarStyles;
    document.head.appendChild(style);
  }
}; 